var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('b-alert',{attrs:{"variant":"primary","show":""}},[_vm._v(_vm._s(_vm.text))]),(_vm.uid_file)?_c('viewFile',{attrs:{"uid_element":_vm.uid_file}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }